import { Badge } from "@radix-ui/themes";

export function getIsAnsweredByAuiText(value: boolean): string {
  return value ? "By AUI" : "Not by AUI";
}

export function IsAnsweredByAuiFormatter({
  value,
  size = "1",
}: {
  value: boolean;
  size?: "1" | "2";
}) {
  return (
    <Badge
      variant={value ? "solid" : "soft"}
      color={value ? "green" : "gray"}
      size={size}
    >
      {getIsAnsweredByAuiText(value)}
    </Badge>
  );
}
